import React from 'react'

import { StyledTopicLabel } from 'component-library/typography/TopicLabel/TopicLabel.styled'
import { toTopicRouteHint } from 'common/routing/route-hints'
import { Topic } from 'common/client-data-types/topic'

export interface Props {
    sizing: 'small' | 'large'
    text: string
    topic: Topic
    className?: string
}

export const TopicLabel: React.FC<Props> = props => (
    <StyledTopicLabel
        to={toTopicRouteHint(props.topic)}
        sizing={props.sizing}
        className={props.className}
    >
        {props.text}
    </StyledTopicLabel>
)
TopicLabel.displayName = 'TopicLabel'
